import { render, staticRenderFns } from "./Changemobile.vue?vue&type=template&id=18362256&scoped=true"
import script from "./Changemobile.vue?vue&type=script&lang=js"
export * from "./Changemobile.vue?vue&type=script&lang=js"
import style0 from "./Changemobile.vue?vue&type=style&index=0&id=18362256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18362256",
  null
  
)

export default component.exports